import * as React from "react";
import MaterialDialog from "material-ui/Dialog";
import {SFC} from "react";

import styles = require("./style.less");
import {dialogClass} from "uiTestClasses";

interface DialogProps {
    open?: boolean;
    wide?: boolean;
    repositionOnUpdate?: boolean;
}

const Dialog: SFC<DialogProps> = props => {

    const bodyStyle = {
        padding: "0",
        color: "inherit",
        fontSize: "inherit",
        display: "flex",
        overflow: "hidden"
    };

    const contentStyle = !props.wide ? {
        width: "75%",
        maxWidth: "550px"
    } : null;

    return <MaterialDialog className={dialogClass}
                           open={props.open || false}
                           bodyStyle={bodyStyle as any}
                           contentStyle={contentStyle}
                           contentClassName={styles.materialDialogContent}
                           autoDetectWindowHeight={true}
                           repositionOnUpdate={props.repositionOnUpdate}>
        {props.open && props.children}
    </MaterialDialog>;
};

Dialog.displayName = "Dialog";

export default Dialog;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Dialog/Dialog.tsx